import styled from 'styled-components'

const FormContainer = styled.form`
  margin-bottom: 2rem;
  width: 100%;
  max-width: 800px;
  padding: 30px;

  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
`

export default FormContainer
